import styled from 'styled-components'
import vertical from '../../assets/vertical.svg'
import add from '../../assets/vuesax-linear-add.svg'
import minus from '../../assets/vuesax-linear-minus.svg'



export const Page17Container = styled.div`
display: flex;
background-color: black;
flex-direction: column;
height: 100vh;
width: 100%;
filter: brightness(${props => props.degree});

@media screen and (max-width: 900px){
    height:100%;
    
}

`
export const Page17Wrapper = styled.div`
margin: 0px 100px;

@media screen and (max-width: 950px){
    margin: 0px 20px;
  }
`
export const Page17Head = styled.div`
display: flex;
justify-content: flex-start;
margin-top: 30px;
width:100%;
`
export const Page17HeadCaption = styled.div`
color: white;
font-size: 32px;
font-weight: bold;
`
export const Page17CardsWrapper = styled.div`
    display: grid;
    grid-template-rows: auto auto auto auto auto auto ;
    grid-row-gap: 20px;
    
`
export const Page17Card = styled.div`
    display:flex;
    background-color: #262626;
    color:white;
    flex-direction:column;
    border-radius: 10px;
    /* width:75vw; */
`
export const Page17CardFirstPart = styled.div`
color: white;
font-size: 20px;
line-height:24px;
padding: 0px 20px;
display:flex;
background-image: url(${vertical});
background-repeat: no-repeat;
background-position: 0% 50%;
height:85px;
/* background-size: 20px; */
-webkit-transition: all 500ms ease;
-moz-transition: all 500ms ease;
-ms-transition: all 500ms ease;
-o-transition: all 500ms ease;
transition: all 500ms ease;
}

&:hover + div {
    display: flex;
    -webkit-transition: all 500s ease;
    -moz-transition: all 500s ease;
    -ms-transition: all 500s ease;
    -o-transition: all 500s ease;
    transition: all 500s ease;
}

&:hover > div {
    background-image: url(${minus}) ;
}

`
export const Page17CardFirstPartText = styled.div`
background-image: url(${add});
background-repeat: no-repeat;
background-position: 95% 50%;
background-size: 20px;
width: 100%;
display:flex;
align-items:center;

@media screen and (max-width: 950px){
    font-size: 14px;
    line-height: 20px;
    padding: 0px 40px 0px 0px;
  }
`
export const Page17CardSecondPart = styled.div`
display: none;
border-top: 0.01cm #595959 solid;
padding: 10px 20px;

@media screen and (max-width: 950px){
    font-size: 14px;
    line-height: 16px;
  }

`
export const Page17CardFirstPartImg = styled.img`
transform: rotate(270deg);
-webkit-transform: rotate(270deg);

`
